import { IPromise } from 'angular';
import * as angular from 'angular';
import { HttpService } from '../../../app.common/modules/api/http.service';
import { RetailerService } from '../api/retailer.service';
import {
    IExcludedCategory,
    IVoucherBase,
    IVoucherEdit,
    IVoucherFilter,
    IVoucherItem,
    IVouchersList,
    IVoucherUpdate
} from './models/models';

export class VouchersService {
    public static $inject = ['http', 'retailerService'];

    constructor(private http: HttpService, private retailerService: RetailerService) {}

    public getVouchersList(filter: IVoucherFilter) {
        return this.http.get<IVouchersList>(this.retailerService.vouchers(), { params: filter });
    }

    public getVoucher(id: number) {
        return this.http.get<IVoucherItem>(this.retailerService.getVoucherById(id));
    }

    public createVoucher(voucher: IVoucherBase) {
        return this.http.post(this.retailerService.vouchers(), voucher);
    }

    public updateVoucher(voucher: IVoucherEdit) {
        return this.http.put(this.retailerService.vouchers(), voucher);
    }

    public deleteVoucher(voucherId: number) {
        const voucher: IVoucherUpdate = {VoucherID: voucherId};
        return this.http.delete(this.retailerService.vouchers(), { params: voucher });
    }

    public publishVoucher(voucherId: number) {
        const voucher: IVoucherUpdate = {VoucherID: voucherId};
        return this.http.patch(this.retailerService.publishVoucher(), voucher);
    }

    public getClassificationCategories(): IPromise<IExcludedCategory[]> {
        return this.http.get<IExcludedCategory[]>(this.retailerService.categoriesForVouchers());
    }

    public getVoucherRestrictedCategories(): IPromise<number[]> {
        return this.http.get<number[]>(this.retailerService.getVoucherRestrictedCategories());
    }
}

angular
    .module('naut')
    .service('vouchersService', VouchersService);



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/vouchers/vouchers.service.ts